import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  TablePagination,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";

import EmptyData from "../../../../../StyledComponents/Table/EmptyData";
import Heading from "../../../../../StyledComponents/Heading/Heading";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function FER_Allowance({ multipleData }) {
  const classes = useStyles();
  const [page, setpage] = useState(0);
  const [RowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setpage(0);
  };

  const [allowanceTable, setAllowanceTable] = useState([]);

  useEffect(() => {
    // Process the data and update state for each table
    const processTables = () => {
      const allowanceTableData = [];

      for (let i = 0; i < multipleData?.fer_Invoice_Detial?.length; i++) {
        const record = multipleData?.fer_Invoice_Detial[i];

        if (record.Category === "Allowance") {
          allowanceTableData.push(record);
        }
      }

      setAllowanceTable(allowanceTableData);
    };

    processTables();
  }, [multipleData]);
  return (
    <div>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          mt={2}
          mb={2}
          style={{ width: "0" }}
        >
          <Heading title="Allowance" />
          <TableContainer
            className="scrollable"
            style={{
              maxHeight: "200px",
              minHeight: "100px",
              overflowY: "auto",
            }}
          >
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Expense Date
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Vehicle No
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Vehicle Type
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Per Diem
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Daily
                  </TableCell>

                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Expense Description/Remarks
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Total Expense Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allowanceTable?.length > 0 &&
                  allowanceTable
                    ?.slice(
                      page * RowsPerPage,
                      page * RowsPerPage + RowsPerPage
                    )
                    .map((item, index) => {
                      return (
                        <TableRow key={index} sx={{ fontSize: "10" }}>
                          <TableCell sx={{ p: 1 }}>
                            {moment(item?.ExpenseDate).format("MM/DD/YYYY")}
                          </TableCell>
                          <TableCell sx={{ p: 1 }}>
                            {item?.Vehicle_No}
                          </TableCell>
                          <TableCell sx={{ p: 1 }}>
                            {item?.Vehicle_Type}
                          </TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Per_Diem}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Daily}</TableCell>
                          <TableCell sx={{ p: 1 }}>
                            {item?.Expense_Remarks}
                          </TableCell>
                          <TableCell sx={{ p: 1 }}>
                            {item?.Total_Expense_Amount}
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
              {/* {loading && <TableSkeleton noOfColumns={9} noOfLines={3} />} */}
            </Table>
            {allowanceTable?.length === 0 ? <EmptyData /> : ""}
            <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={allowanceTable?.length}
              rowsPerPage={RowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}

export default FER_Allowance;
